import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import "./index.css";
import { detectDemo, startDemo } from "./demo";
import { initTelegram, loadThemePref } from "./lib/tg";

async function boot() {
  initTelegram();
  loadThemePref();
  if (detectDemo()) await startDemo();
  else if (import.meta.env.VITE_API_MOCK === "1") {
    const { installMock } = await import("./api/mock");
    installMock();
  }
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
boot();
